import styled from '@emotion/styled';
import { Variables } from '../../base';

export const CodeKeyCard = styled.div`
    margin-top: 24px;
    background: ${Variables.Swatches.White};
    border: 1px solid ${Variables.Colors.n30};
    border-radius: 8px;
    padding: 18px 22px;
`;

export const CodeKeyTitle = styled.div`
    margin-bottom: 14px;
    font-size: 12px;
    font-weight: 600;
    line-height: 1.3;
    color: ${Variables.Colors.n70};
    text-transform: uppercase;
    letter-spacing: 0.05em;
`;

export const CodeKeyGrid = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 12px 32px;

    @media (max-width: 720px) {
        grid-template-columns: 1fr;
    }
`;

export const CodeKeyItem = styled.div`
    display: flex;
    gap: 10px;
    align-items: baseline;
`;

export const CodeBadge = styled.span<{ tone?: 'neutral' | 'warning' }>`
    flex: none;
    width: 54px;
    padding: 2px 7px;
    border-radius: 4px;
    text-align: center;
    font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, 'Liberation Mono', 'Courier New',
        monospace;
    font-size: 11px;
    font-weight: 600;
    line-height: 1.4;
    background: ${props => (props.tone === 'warning' ? '#FBEFD9' : '#F0F3F6')};
    color: ${props => (props.tone === 'warning' ? '#8A5E1C' : '#4F5F76')};
    border: 1px solid ${props => (props.tone === 'warning' ? '#F0D79B' : '#DAE0E7')};
`;

export const CodeKeyCopy = styled.div`
    min-width: 0;
`;

export const CodeKeyItemTitle = styled.span`
    font-size: 14px;
    font-weight: 600;
    line-height: 1.35;
    color: ${Variables.Colors.n100};
`;

export const CodeKeyItemDesc = styled.div`
    margin-top: 1px;
    font-size: 13px;
    line-height: 1.4;
    color: ${Variables.Colors.n70};
`;
